import { useEffect, useMemo, useRef } from "react";

import { debounce } from "lodash";

// based on: https://www.developerway.com/posts/debouncing-in-react
export const useDebounce = (callback: Function, wait?: number) => {
    const ref = useRef<Function>();
  
    useEffect(() => {
      ref.current = callback;
    }, [callback]);
  
    const debouncedCallback = useMemo(() => {
      const func = () => {
        ref.current?.();
      };
  
      return debounce(func, wait);
    }, []);
  
    return debouncedCallback;
  };